import {PolarResources} from '@packages/domains/identity-and-access/role-based-access/policy';

import {
  type SiteResourceQueryType,
  SiteResourceQueryTypes,
} from './authorization';
import type {OsoResourceType} from './polar-extended';

/** Every own key of the generated authorization policy map (resources and actors). */
export type AuthorizationPolicyTypeKey = keyof typeof PolarResources;

export const AuthorizationPolicyTypeKeys: ReadonlySet<AuthorizationPolicyTypeKey> =
  new Set(Object.keys(PolarResources) as AuthorizationPolicyTypeKey[]);

/**
 * True for any own policy type key, including actor types (`User`, `SiteRole`, …)
 * that `isOsoResourceType` excludes.
 */
export const isAuthorizationPolicyTypeKey = (
  resourceType: string
): resourceType is AuthorizationPolicyTypeKey =>
  AuthorizationPolicyTypeKeys.has(resourceType as AuthorizationPolicyTypeKey);

// Get resource types by filtering out actor types (those with empty permissions and roles)
export const PolarResourceTypes = new Set(
  Object.keys(PolarResources).filter((key) => {
    const resource = PolarResources[key as keyof typeof PolarResources];
    // Actor types have both empty permissions and empty roles arrays
    return !(resource.permissions.length === 0 && resource.roles.length === 0);
  })
);

export const isOsoResourceType = (
  resourceType: string
): resourceType is OsoResourceType => PolarResourceTypes.has(resourceType);

export const isSiteResourceQueryType = (
  resourceType: string
): resourceType is SiteResourceQueryType =>
  SiteResourceQueryTypes.has(resourceType);
